<template>
  <div v-if="!loading" class="auth-layout-wrap">
    <div class="auth-content">
      <div class="card o-hidden">
        <div class="row">
          <div class="col-md-12">
            <div class="p-4">
              <div class="auth-logo text-center mb-30">
                <img :src="logo" />
              </div>
              <h1 class="mb-3 text-18">Reset Password</h1>
              <ApolloMutation
                :mutation="require('@/graphql/Account/ResetPassword.gql')"
                :variables="{
                  email: tokenUser.email,
                  password: password,
                  confirmPassword: confirmPassword
                }"
                @done="resetPasswordSuccess"
              >
                <template v-slot="{ mutate }">
                  <b-form-group label="Password" class="text-12">
                    <b-form-input
                      v-model="password"
                      class="form-control-rounded"
                      :type="passwordType"
                    ></b-form-input>
                    <b-icon-eye
                      v-if="passwordEye"
                      class="pass-eye"
                      @click="passwordEye = !passwordEye"
                    />
                    <b-icon-eye-slash
                      v-else
                      class="pass-eye"
                      @click="passwordEye = !passwordEye"
                    />
                  </b-form-group>
                  <b-form-group label="Confirm Password" class="text-12">
                    <b-form-input
                      v-model="confirmPassword"
                      class="form-control-rounded"
                      :type="confirmPasswordType"
                    ></b-form-input>
                    <b-icon-eye
                      v-if="confirmPasswordEye"
                      class="pass-eye"
                      @click="confirmPasswordEye = !confirmPasswordEye"
                    />
                    <b-icon-eye-slash
                      v-else
                      class="pass-eye"
                      @click="confirmPasswordEye = !confirmPasswordEye"
                    />
                  </b-form-group>
                  <b-button
                    type="submit"
                    tag="button"
                    class="btn-rounded btn-block mt-2"
                    variant="primary mt-2"
                    @click.prevent="validateResetPassword(mutate)"
                  >
                    Confirm
                  </b-button>
                </template>
              </ApolloMutation>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import validator from "password-validator"
import { mapGetters } from "vuex"
export default {
  name: "ResetPassword",
  data() {
    return {
      passwordEye: false,
      confirmPasswordEye: false,
      password: "",
      confirmPassword: "",
      schema: null,
      logo: require("@/assets/images/logo2.png"),
      tokenUser: null,
      loading: true
    }
  },
  computed: {
    ...mapGetters({
      currentUser: "getCurrentUser"
    }),
    confirmPasswordType() {
      return !this.confirmPasswordEye ? "password" : "text"
    },
    passwordType() {
      return !this.passwordEye ? "password" : "text"
    }
  },
  async created() {
    const token = this.$route.params.token
    if (!token) this.$router.push("/")

    const resp = await this.$apollo.mutate({
      mutation: require("@/graphql/Account/VerifyResetToken.gql"),
      variables: {
        token: token
      }
    })
    if (!resp.data.verifyResetToken) this.$router.push("/")
    //this returns the user associated with the token
    else {
      const user = await this.$apollo.mutate({
        mutation: require("@/graphql/Account/GetTokenUser.gql"),
        variables: {
          token: token
        }
      })
      this.tokenUser = user.data.getTokenUser
    }

    this.schema = new validator()
    this.schema
      .is()
      .min(8) // Minimum length 8
      .is()
      .max(15) // Maximum length 15
      .has()
      .uppercase() // Must have uppercase letters
      .has()
      .lowercase() // Must have lowercase letters
      .has()
      .digits() // Must have digits
      .has()
      .not()
      .spaces() // Should not have spaces
      .is()
      .not()
      .oneOf(["Passw0rd", "Password123"]) // Blacklist these values

    this.loading = false
  },
  methods: {
    /**
     * Validates reset pass form
     * @param mutate
     */
    validateResetPassword(mutate) {
      if (this.password !== this.confirmPassword)
        return this.$toasted.error("Passwords do not match.")
      const errors = this.schema.validate(this.password, { list: true })

      if (errors.length) {
        if (errors.includes("min"))
          return this.$toasted.error("Minimum password length is 8")
        if (errors.includes("max"))
          return this.$toasted.error("Maximum password length is 15")
        if (errors.includes("uppercase"))
          return this.$toasted.error(
            "Password does not contain an uppercase letter"
          )
        if (errors.includes("lowercase"))
          return this.$toasted.error(
            "Password does not contain a lowercase letter"
          )
        if (errors.includes("digits"))
          return this.$toasted.error("Password does not contain any digits")
        if (errors.includes("oneOf"))
          return this.$toasted.error("Blacklisted password used")

        return
      }
      mutate()
    },
    /**
     * Notifies user the operations successfully completed.
     * Returns user to login screen
     */
    resetPasswordSuccess() {
      this.$toasted.success("Password reset")
      this.$router.push("/Authentication/Login")
    }
  }
}
</script>

<style scoped>
.auth-layout-wrap .auth-content {
  min-width: 25rem;
}
.auth-logo img {
  /* height: 100px; */
  width: unset;
  margin-bottom: 1.5rem;
}
.pass-eye {
  cursor: pointer;
  position: absolute;
  top: 2rem;
  right: 1rem;
  font-size: large;
}
</style>
